import { render, staticRenderFns } from "./card-detail.vue?vue&type=template&id=3c4b89af&scoped=true&"
import script from "./card-detail.vue?vue&type=script&lang=js&"
export * from "./card-detail.vue?vue&type=script&lang=js&"
import style0 from "./card-detail.vue?vue&type=style&index=0&id=3c4b89af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b89af",
  null
  
)

export default component.exports